import { render } from "./TipuriDocumenteHR.vue?vue&type=template&id=a9b1b900&ts=true"
import script from "./TipuriDocumenteHR.vue?vue&type=script&lang=ts"
export * from "./TipuriDocumenteHR.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__